











































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { appModule } from "@/store/modules/app";
import PermintaanObatPaketSvc from "@/services/PermintaanObatPaket";
import AntimikrobaReserveForm from "./AntimikrobaReserveForm.vue";
import { statusAlur as labelStatusAlur } from "./antimikrobaReserve.config";

@Component({
  components: {
    AntimikrobaReserveForm,
  },
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class AntimikrobaReserveList extends Vue {
  @Prop() register!: string;
  @Prop() rm!: string;
  isReadOnly!: () => boolean;

  confirmKirim = false;
  sending = false;

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  get draftItem() {
    return this.items.find(i => i.status_alur === "draft") || null;
  }

  showForm = false;
  showDetail = false;
  selectedItem: any = null;
  editData: any = null;
  confirmDelete = false;
  deleteTarget: any = null;
  deleting = false;
  loading = false;

  items: any[] = [];

  tableHeaders = [
    { text: "Nama DPJP", value: "dpjp", width: "180px", sortable: false },
    { text: "Diagnosa", value: "diagnosa", width: "200px", sortable: false },
    { text: "Keadaan Umum", value: "keadaan_umum", width: "120px", sortable: false },
    { text: "Status", value: "status_alur", width: "140px", sortable: false },
    { text: "Rek. KPRA", value: "rekomendasi_kpra", width: "130px", sortable: false },
    { text: "TTD DPJP", value: "signed_dpjp", width: "100px", sortable: false },
    { text: "Aksi", value: "actions", sortable: false, width: "160px" },
  ];

  get hasData() {
    return this.items.length > 0;
  }

  mounted() {
    this.loadList();
  }

  @Watch("register")
  onRegisterChange() {
    this.showForm = false;
    this.showDetail = false;
    this.loadList();
  }

  async loadList() {
    this.loading = true;
    try {
      const resp = await PermintaanObatPaketSvc.getByRegister(this.register, "antimikroba_reserve");
      if (resp.data.status === "1" && resp.data.data) {
        this.items = [resp.data.data];
      } else {
        this.items = [];
      }
    } catch {
      this.items = [];
    }
    this.loading = false;
  }

  tambah() {
    this.showForm = true;
    this.editData = null;
  }

  lihat(item: any) {
    this.selectedItem = item;
    this.showDetail = true;
  }

  edit(item: any) {
    this.editData = item;
    this.showForm = true;
  }

  cancelForm() {
    this.showForm = false;
    this.editData = null;
  }

  onSaved() {
    this.showForm = false;
    this.showDetail = false;
    this.editData = null;
    this.selectedItem = null;
    this.loadList();
  }

  cetakPdf(item: any) {
    PermintaanObatPaketSvc.print(item.id);
  }

  statusAlur(status: string) {
    return labelStatusAlur(status);
  }

  async doKirim() {
    if (!this.draftItem || this.readOnly) return;
    this.sending = true;
    try {
      await PermintaanObatPaketSvc.kirim(this.draftItem.id);
      appModule.NoticeDelay("Permintaan berhasil dikirim ke farmasi");
      this.confirmKirim = false;
      await this.loadList();
    } catch {
      // handled by service
    } finally {
      this.sending = false;
    }
  }

  hapus(item: any) {
    this.deleteTarget = item;
    this.confirmDelete = true;
  }

  async doDelete() {
    if (!this.deleteTarget) return;
    this.deleting = true;
    try {
      const resp = await PermintaanObatPaketSvc.destroy(this.deleteTarget.id);
      if (resp && resp.status == 1) {
        appModule.NoticeDelay("Berhasil menghapus permintaan");
        this.confirmDelete = false;
        this.deleteTarget = null;
        await this.loadList();
      }
    } catch {
      // handled by service
    } finally {
      this.deleting = false;
    }
  }
}
